import React, { useState, useEffect, useRef } from 'react';
import styles from './BeforeAfterSlider.module.scss';
import { data } from './data';
import { SliderModal } from './SliderModal/SliderModal';
interface BeforeAfterSliderProps {
  fullscreen?: boolean;
}
export const BeforeAfterSlider: React.FC<BeforeAfterSliderProps> = ({ fullscreen = false }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  // const [isSliderOpen, setIsSliderOpen] = useState(false);
  const handleInteraction = () => {
    isInteracted.current = true;
    setIsDragging(true); // Включаем класс .big

    // Очищаем предыдущий таймер, если пользователь все еще двигает ползунок
    if (dragTimeoutId.current !== null) {
      window.clearTimeout(dragTimeoutId.current);
    }

    // Ставим новый таймер на полсекунды
    dragTimeoutId.current = window.setTimeout(() => {
      setIsDragging(false); // Выключаем класс .big
    }, 100);
  };

  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleInteraction();
    setSliderPosition(Number(event.target.value));
  };

  const sliderLength = data.length;
  const [currentIndexSlider, setCurrentIndexSlider] = useState(0)


  const isInteracted = useRef(false);
  const animationFrameId = useRef<number>(0);
  const animationTimeoutId = useRef<number | null>(null);

  const [isDragging, setIsDragging] = useState(false);
  const dragTimeoutId = useRef<number | null>(null);


  const toggleSliderRight = () => {
    isInteracted.current = true;
    setCurrentIndexSlider(prevIndex => prevIndex < sliderLength - 1 ? prevIndex + 1 : prevIndex);
  }

  const toggleSliderLeft = () => {
    isInteracted.current = true;
    setCurrentIndexSlider(prevIndex => prevIndex > 0 ? prevIndex - 1 : 0)
  }

  const formatPrice = (value: number): string => {
    return new Intl.NumberFormat('ru-RU').format(value);
  };

  const animateSlider = (first: number, second: number, delay: number, easeFactor: number) => {
    cancelAnimationFrame(animationFrameId.current);
    if (animationTimeoutId.current !== null) {
      clearTimeout(animationTimeoutId.current);
    }
    isInteracted.current = false;

    let currentPos = sliderPosition;
    const sequence: number[] = [currentPos + first, currentPos + second, currentPos]
    let seqIndex = 0;

    const animate = () => {
      if (isInteracted.current || seqIndex >= sequence.length) return;

      const target = sequence[seqIndex];
      const diff = target - currentPos;

      if (Math.abs(diff) < 0.5) {
        currentPos = target;
        seqIndex++;
      } else {
        currentPos += diff * easeFactor;
      }

      setSliderPosition(currentPos);
      animationFrameId.current = requestAnimationFrame(animate);
    };

    animationTimeoutId.current = window.setTimeout(() => {
      animationFrameId.current = requestAnimationFrame(animate);
    }, delay);
  };

  useEffect(() => {
    animateSlider(55, -55, 500, 0.04);

    return () => {
      cancelAnimationFrame(animationFrameId.current);
      if (animationTimeoutId.current !== null) {
        clearTimeout(animationTimeoutId.current);
      }
      // Очищаем таймер CSS-класса
      if (dragTimeoutId.current !== null) {
        clearTimeout(dragTimeoutId.current);
      }
    };
  }, []);



  return (
    <div className={`${styles.heroSliderWrapper} ${fullscreen ? styles.isFullscreen : ''}`}>
      <div className={styles.top}>
        {/* <div className={styles.leftSide}>
          <button className={styles.fullscreen} onClick={() => setIsSliderOpen(true)}>
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
              <path d="M200-120q-33 0-56.5-23.5T120-200v-160h80v160h160v80H200Zm400 0v-80h160v-160h80v160q0 33-23.5 56.5T760-120H600ZM120-600v-160q0-33 23.5-56.5T200-840h160v80H200v160h-80Zm640 0v-160H600v-80h160q33 0 56.5 23.5T840-760v160h-80Z" />
            </svg>
          </button>
        </div> */}
        <div className={`${styles.price} ${sliderPosition <= 0 ? styles.good : ""} ${sliderPosition >= 100 ? styles.bad : ""} ${isDragging ? styles.big : ""}`}>
          <span><span className={styles.priceStrong}>{formatPrice(Math.round(data[currentIndexSlider].afterPrice - (data[currentIndexSlider].afterPrice - data[currentIndexSlider].beforePrice) * sliderPosition / 100))} ₽</span> <span className={styles.opacity05text}>{data[currentIndexSlider].type[1]}</span></span>
        </div>
        <div className={styles.buttons}>
          <button onClick={toggleSliderLeft} className={`${styles.buttonSwipe} ${styles.buttonToLeft} ${currentIndexSlider <= 0 ? styles.inactive : ""}`} >
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="-225 -960 960 960" width="20px" fill="white">
              <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
            </svg>
          </button>
          <button onClick={toggleSliderRight} className={`${styles.buttonSwipe} ${styles.buttonToLeft} ${currentIndexSlider >= sliderLength - 1 ? styles.inactive : ""}`}>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="-72 -960 960 960" width="20px" fill="white">
              <path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" />
            </svg>
          </button>
        </div>
      </div>
      <div className={styles.heroSlider}>

        <div className={styles.container}>
          {/* Изображение "После" (на заднем фоне) */}
          <img src={`img/after/${currentIndexSlider + 1}.jpg`} alt="После" className={styles.image} />
          <div className={styles.badgeAfter}>После</div>

          {/* Обертка "До" (обрезается с помощью маски clip-path) */}
          {/* inset(0 X% 0 0) обрезает X процентов справа */}
          <div
            className={styles.beforeWrapper}
            style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
          >
            <img src={`img/before/${currentIndexSlider + 1}.jpg`} alt="До" className={styles.imageBefore} />
            <div className={styles.badgeBefore}>До</div>
          </div>

          {/* Разделительная линия */}
          <div
            className={styles.sliderLine}
            style={{
              left: `${sliderPosition}%`,
              /* Если ползунок у краев (<= 1% или >= 99%), скрываем линию */
              backgroundColor: (sliderPosition <= 1 || sliderPosition >= 99)
                ? 'transparent'
                : '#ffffff'
            }}
          >
            <div className={styles.sliderButton}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'translateX(-7px)' }} />
                <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ transform: 'translateX(7px)' }} />
              </svg>
            </div>
          </div>

          {/* Невидимый ползунок для управления */}
          <input
            type="range"
            min="0"
            max="100"
            value={sliderPosition}
            onChange={handleSliderChange}
            onMouseDown={handleInteraction}
            onTouchStart={handleInteraction}
            className={styles.slider}
          />
        </div>
      </div>
      {/* <SliderModal
        isOpen={isSliderOpen}
        onClose={() => setIsSliderOpen(false)}
      /> */}
    </div>
  );
};